/**
 * 建立多階層工單頁：entrySource 解析（客訂 vs 工單進入）。
 */

/**
 * @param {URLSearchParams|null|undefined} searchParams
 * @returns {'customerOrder'|'workOrder'}
 */
export function resolveManufacturingMaterialsEntrySource(searchParams) {
  const entrySource = searchParams?.get('entrySource');
  const from = searchParams?.get('from');
  if (entrySource === 'workOrder' || from === 'work-order') {
    return 'workOrder';
  }
  return 'customerOrder';
}

/** 客訂進入＝來源鎖定；工單進入＝可改選。 */
export function isManufacturingMaterialsSourceLocked(entrySource) {
  return entrySource !== 'workOrder';
}
